import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { PlatformModule } from '@app/modules/platform/platform.module';
import { UserInfoRoutes } from '@app/modules/user-info/routes/user-info.routes';
import { environment } from '@environments/environment';
import { permissions } from '@environments/shared';
import { ZonarUiAnalyticsService } from '@app/modules/analytics';
import { ZonarUiAuthModule, ZonarUiPermissionsModule } from '@app/modules/auth';
import { FourOhFourRoutes, ZonarUICoreModule, ZonarUiFaviconModule } from '@app/modules/core';
import { ZonarUiIconModule } from '@livemaps/icon';
import { ZonarUIMaterialModule } from '@livemaps/material';
import { ZonarUiNotificationsModule } from '@livemaps/notifications';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@livemaps/i18n';
import { CookieService } from 'ngx-cookie-service';
import { CoreCompanyApiService } from '@app/modules/auth';
import { AuthService } from '@auth0/auth0-angular';
import { zonarUiAnalyticsFactory } from './utilities/utilities';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    ZonarUICoreModule,
    ZonarUiFaviconModule,
    ZonarUIMaterialModule,
    ZonarUiNotificationsModule,
    ZonarUiIconModule,
    HttpClientModule,
    HttpClientJsonpModule,
    PlatformModule,
    FlexLayoutModule,
    AppRoutingModule,
    UserInfoRoutes,
    FourOhFourRoutes,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    BrowserModule,
    BrowserAnimationsModule,
    ZonarUICoreModule,
    ZonarUiFaviconModule,
    ZonarUIMaterialModule,
    ZonarUiNotificationsModule,
    ZonarUiIconModule,
    HttpClientModule,
    HttpClientJsonpModule,
    PlatformModule,
    FlexLayoutModule,
    AppRoutingModule,
    UserInfoRoutes,
    FourOhFourRoutes
  ],
  providers: [
    {
      provide: ZonarUiAnalyticsService,
      useFactory: zonarUiAnalyticsFactory,
      deps: [CookieService, CoreCompanyApiService, AuthService]
    },
    { provide: 'pendoParams', useValue: environment.pendo },

    // Auth settings
    { provide: 'applicationId', useValue: environment.auth.applicationId },
    { provide: 'environment', useValue: environment.authEnv },
    { provide: 'defaultPermPrefix', useValue: permissions.defaultPermPrefix },
    { provide: 'routePermissions', useValue: permissions.routes },
    { provide: 'redirectUrl', useValue: permissions.defaultRedirectUrl },
    { provide: 'logoutReturnToUrl', useValue: environment.appUrl },
    ZonarUiAuthModule,
    ZonarUiPermissionsModule
  ]
})
export class CoreModule {}
